import AssessmentView from './AssessmentView'
export default AssessmentView
